import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography, Grid, Box, Card, Avatar, CircularProgress, Button } from '@material-ui/core';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import { IdeaCss } from '../IdeaCss';
import { ideaActions } from '../../../actions';
import { useIdeaDetailsController } from '../../../containers/IdeaDetailsPage/hooks/useIdeaDetailsController';

export function IdeaVote() {
  const classes = IdeaCss();
  const dispatch = useDispatch();
  const { hasIdeaFlux } = useIdeaDetailsController();
  const user = useSelector(state => state.user);
  const { loadingUp } = useSelector(state => state.idea);

  function upIdeaInDetails() {
    dispatch(ideaActions.upIdeaInDetails(hasIdeaFlux._id));
  }

  return (
    <Grid item xs={12}>
      <Card elevation={0} className={classes.cardSmall}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Avatar className={classes.avatarIcon}>
                <ThumbUpAltIcon color="primary" fontSize="small" />
              </Avatar>
              <Typography variant="subtitle1">Votar</Typography>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography variant="subtitle2">quantidade de votos</Typography>
              <Typography variant="body2">{hasIdeaFlux?.ups?.length}</Typography>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Button
              color="primary"
              variant="contained"
              onClick={upIdeaInDetails}
              style={{ height: 47, width: '100%' }}
              disabled={loadingUp}
            >
              {loadingUp ? (
                <CircularProgress color="primary" size={25} />
              ) : (
                hasIdeaFlux?.ups !== undefined &&
                hasIdeaFlux?.ups.filter(item => item === user._id))[0]
                ? 'Remover voto' 
                : 'Votar nesse case'
              }
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}
